import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAcceptSupervisor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 23" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        d="M.632 5v12M6.947 5v12m5.67-15.882c.808-.06 1.316-.098 1.524-.112 1.149-.087 2.025.566 2.628 1.958.905 2.089 2.273 7.967.397 16.076-.298 1.903-1.46 2.747-2.528 2.618a88.727 88.727 0 0 0-2.067-.225c-.835-.164-1.176-.764-1.024-1.8.227-1.555.177-1.037.387-2.284.21-1.247.319-1.13 1.68-1.74 1.36-.609 1.717-.282 1.728-2.177.007-1.263-.037-2.933-.132-5.01.01-.736-.442-1.172-1.355-1.309-1.37-.206-1.682-.507-2.014-1.944a23.43 23.43 0 0 1-.473-2.757c.025-.802.442-1.234 1.25-1.294z"
      />
      <path
        fill="#FFF"
        d="m25.621.672.707.707-4.95 4.95-.706-.708zm0 19.656.707-.707-4.95-4.95-.706.708zM21 10h6v1h-6z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgAcceptSupervisor);
export default Memo;
